<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.ip_settings")')
          b-card
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="ipList" :fields="fields" :filter="filter" thead-class="grey")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(account_id)="row")
                    span #[b {{ row.item.account_id.toUpperCase() }}]
                  template(v-slot:cell(ip)="row")
                    template(v-if="row.item.ip" v-for="item in row.item.ip.split(',').sort()")
                      span.label.label-inverse.ml-1.align-middle {{ item }}
                  template(v-slot:cell(updated_on)="row")
                    span {{ $moment(row.item.updated_on).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(updated_by)="row")
                    span {{ row.item.updated_by.toUpperCase() }}
                  template(v-slot:cell(action)="row")
                    div.d-flex.flex-nowrap(style="justify-content: center;")
                      span
                        a.fas.fa-lg.fa-fw.fa-edit.text-primary(
                          v-b-modal.configIp
                          @click="setEditSelectedModal(row.item)"
                          :title="$t('ui.edit')"
                          style="cursor: pointer;"
                        )
      configIp(:accountId="updateAccountID" :ipArr="updateIpArr" @clicked="submit")
</template>

<script>
import SubmitButton from "@/library/SubmitButton"
import configIp from "@/components/modal/configIp.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    configIp,
    DebounceInput
  },
  data() {
    return {
      account_id: "",
      ipList: [],
      updateAccountID: "",
      updateIpArr: [],
      loading: false,
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "account_id",
          label: this.$t("ui.username"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "ip",
          label: this.$t("ui.ip"),
          class: "align-middle",
          thClass: "bg-grey"
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          class: "align-middle text-center",
          thClass: "bg-grey",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "updated_by",
          label: this.$t("ui.updated_by"),
          class: "align-middle",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        },
        {
          key: "updated_on",
          label: this.$t("ui.updated_on"),
          class: "align-middle text-right",
          thClass: "bg-grey",
          thStyle: {
            width: "13%"
          }
        }
      ]
    }
  },
  mounted: function(){
    this.submit()
  },
  methods: {
    setEditSelectedModal: function(account) {
      this.updateAccountID = account.account_id
      this.updateIpArr = account.ip.split(',').filter(function (x) { return x.toString().trim() != ''})
    },
    submit: function() {
      if (!this.$v.$invalid) {
        this.loading = true
        this.$store
          .dispatch("user/getIpList", {})
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            if (this.submission.success == true) {
              this.ipList = response.data
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
}
</script>
